// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__24Fff","title":"InfoRow_title__QDyZp"};